export const TEAM_TYPES = {
  PRIMARY: "primary",
  MY: "my",
  OPPONENT: "opponent",
} as const;
